/**
 * Default sort for specific collections by metafield values.
 * Currently: oem-straps → brand A→Z, then material A→Z.
 */

const SORT_CONFIG = {
  'oem-straps': ['data-sort-brand', 'data-sort-material'],
};

function sortGrid(grid, observer) {
  const items = Array.from(grid.querySelectorAll(':scope > [data-sort-brand]'));
  if (!items.length) return;

  const sortKeys = SORT_CONFIG[grid.dataset.collectionHandle];
  if (!sortKeys) return;

  const sorted = [...items].sort((a, b) => {
    for (const key of sortKeys) {
      const va = (a.getAttribute(key) || '').trim();
      const vb = (b.getAttribute(key) || '').trim();
      if (va < vb) return -1;
      if (va > vb) return 1;
    }
    return 0;
  });

  // No-op check: avoid DOM writes (and mutation cascades) if already in order
  if (sorted.every((el, i) => el === items[i])) return;

  // Moving nodes fires our own observer — disconnect while reordering
  if (observer) observer.disconnect();
  sorted.forEach((item) => grid.appendChild(item));
  if (observer) observer.observe(grid, { childList: true });
}

function init() {
  const params = new URLSearchParams(window.location.search);
  if (params.has('sort_by')) return;

  const grid = document.querySelector('[ref="grid"][data-collection-handle]');
  if (!grid || !SORT_CONFIG[grid.dataset.collectionHandle]) return;

  sortGrid(grid);

  // Re-sort when infinite scroll appends new cards
  const observer = new MutationObserver(() => sortGrid(grid, observer));
  observer.observe(grid, { childList: true });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
